
let registeredIds = [];

class CardEditorBase {

    constructor(cardPropName) {
        this.cardPropName = cardPropName;

        this.activeTab = ko.observable('general');

        this.targetElementAdjustShown = ko.observable(false);

        if (!registeredIds[cardPropName]) {
            registeredIds[cardPropName] = [];
        }

        this.mightSelectorBeGenerated = ko.pureComputed(() => {
            const sel = ko.unwrap(this.currentSelectorObservable);
            const res = /\_\_\_[A-Za-z0-9]*([a-zA-Z]+[0-9]+|[0-9]+[a-zA-Z]+)/gmi.test(sel) ||
                /css\-[a-zA-Z0-9]+/gmi.test(sel) ||
                /[0-9]{2,}/gmi.test(sel);

            return res;
        });
    }

    get currentSelectorObservable() {
        return null;
    }

    setActiveTab(tab) {
        this.activeTab(tab);
    }

    listenToThisIdOnce(eventName, id, callback) {
        if (registeredIds[this.cardPropName].indexOf(id) !== -1) return;

        registeredIds[this.cardPropName].push(id);

        this.listenToThisId(eventName, id, callback);
    }

    listenToThisId(eventName, id, callback) {
        document.addEventListener(eventName, data => {
            if (data.detail.cardId === id) {
                callback(data);
            }
        });
    }
}

export default CardEditorBase;